import { configureStore } from "@reduxjs/toolkit";
import rtkQueryErrorLogger from "middlewares/rtkQueryErrorLogger";
import { accountApi } from "store/account";
import { datacontrolApi } from "store/datacontrol";
import { masterdataApi } from "store/masterdata";
import { systemApi } from "store/system";
import { monitoringApi } from "store/monitoring";
import { uploadApi } from "store/upload";
import { dispatchApi } from "store/dispatch";
import { generalApi } from "store/general";
import { datesManagementApi } from "store/datesManagement";
import { activateReservesApi } from "store/activateReserves";
import { healthcheckApi } from "store/healthcheck";

export const store = configureStore({
  reducer: {
    [accountApi.reducerPath]: accountApi.reducer,
    [masterdataApi.reducerPath]: masterdataApi.reducer,
    [systemApi.reducerPath]: systemApi.reducer,
    [datacontrolApi.reducerPath]: datacontrolApi.reducer,
    [monitoringApi.reducerPath]: monitoringApi.reducer,
    [uploadApi.reducerPath]: uploadApi.reducer,
    [dispatchApi.reducerPath]: dispatchApi.reducer,
    [generalApi.reducerPath]: generalApi.reducer,
    [datesManagementApi.reducerPath]: datesManagementApi.reducer,
    [activateReservesApi.reducerPath]: activateReservesApi.reducer,
    [healthcheckApi.reducerPath]: healthcheckApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      accountApi.middleware,
      masterdataApi.middleware,
      systemApi.middleware,
      datacontrolApi.middleware,
      monitoringApi.middleware,
      uploadApi.middleware,
      dispatchApi.middleware,
      generalApi.middleware,
      datesManagementApi.middleware,
      activateReservesApi.middleware,
      healthcheckApi.middleware,
      rtkQueryErrorLogger
    ),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
